import { IValueData } from 'data';
import { IBaseProps } from './../../types/data';
import { EEventType } from './../../enums/EEventType';
import { IOYFilterBarSaveListProps, ISaveListData } from './components/OYFilterBarSaveList/const';

export enum EFilterBarEvent {
  onFeedbackClick = 'onFeedbackClick',
  // onFeedbackClose = 'onFeedbackClose',
  onSaveListDelete = 'onSaveListDelete',
  onSaveListClick = 'onSaveListClick',
  onTagRemove = 'onTagRemove',
  onTagReset = 'onTagReset',
  onChannelClick = "onChannelClick",
  onSaveIconClick = 'onSaveIconClick',
  onCloseSaveTips = 'onCloseSaveTips'
}

export type FilterBarEnentType = EFilterBarEvent & EEventType;

export type Props = IBaseProps & Pick<IOYFilterBarSaveListProps, 'activedSaveName'>;

export interface IOYFilterBarProps extends Props {
  /**
   * 频道值
   */
  channelValue?: string[];
  /**
   * 频道数据
   */
  channel?: IValueData[];
  /**
   * 标签
   */
  tags?: IOYFilterBarTag[];
  /**
   * 是否显示快速查询列表
   */
  showFastQueryList?: boolean;
  /**
   * 快速查出列表
   */
  fastQueryList?: ISaveListData[];
  /**
   * 总数量
   */
  count?: number;
  /**
   * 总重量
   */
  totalWeight?: number | string;
  // /**
  //  * 是否显示反馈icon
  //  */
  // feedback?: boolean;
  /**
   * 是否显示反馈tooltip
   * @deprecated 逻辑移除
   */
  // feedbackTooltip?: boolean | ((...args: any[]) => boolean);
  /**
   * 展示的操作
   */
  operations?: string[];
  /**
   * 自定义如何渲染右侧
   */
  renderRight?: (count: number, totalWeight: number) => string;
  /**
   * 点击移除标签
   * @param data
   * @param index
   */
  onRemove?(data: IOYFilterBarTag, index: number): void;
  /**
   * 点击重置标签
   */
  onReset?(): void;
  /**
   * 点击反馈
   */
  onFeedbackClick?(): void;
  /**
   * 点击保存筛选条件
   */
  onSave?(tags: IOYFilterBarTag[]): void;
  /**
   * 点击保存icon图标
   */
  onSaveIconClick?(): void;
  /**
   * 点击已保存筛选条件
   */
  onSaveListClick?(value: ISaveListData, index: number, list: ISaveListData[]): void;
  /**
   * 点击删除已保存筛选条件
   */
  onSaveListDelete?(value: ISaveListData, index: number, list: ISaveListData[]): void;
}

export interface IOYFilterBarTag {
  title: string;
  value: string;
  key: string;
  global: 0 | 1 | undefined;
  parent?: any;
  // data: {
  //   key: string;
  //   value: string | string[];
  // }
}

export interface IOYFilterBarState {
  /**
   * 是否渲染频道
   */
  isRenderChannel: boolean;
}

export enum EOperation {
  Reset = 'reset',
  Save = 'save',
  SaveList = 'saveList',
  Feedback = 'feedback',
  New = 'new',
}



// WEBPACK FOOTER //
// ./src/components/OYFilterBar/const.ts